const constants = {
  FINISHED: 'finished',
  PLAN_TO_READ: 'plan_to_read',
  READING: 'reading',
  USER_BOOKS_KEY: 'user_books',
  BEST_SELLER_KEY: 'best_seller',
  USER_KEY: 'user',
  LAST_SEARCH_PARAMS: 'last_search_params',
};

export default constants;
